import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';
import { ThemeContext } from 'styled-components';
import { PrivacyPolicyText } from '../../styles';
import { StyledLink } from '../Link';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectSiteHeader } from '../../../../../../store/features/siteHeader';
import { TenantDomainId } from '../../../../../../store/features/pageConfig';

const PolicyContent = (props) => {
  const { buttonText, pageConfig: { tenantId } = {} } = props;

  const { t } = useTranslation();
  const themeConfig = useContext(ThemeContext);
  const { data: { title = '' } = {} } = useRootSelector(selectSiteHeader);

  const vStyles = themeConfig.module.vStyles;

  if (tenantId === TenantDomainId.FANEXPOHQ) {
    return (
      <PrivacyPolicyText
        className="text-center"
        visualStyles={vStyles}
        data-testid={'email-opt-in-privacy-policy'}
      >
        <Trans
          i18nKey="site.email-opt-in.privacy-policy.fanexpo.definition"
          values={{
            siteName: title,
            termsConditions: t(
              'site.email-opt-in.terms-conditions.fanexpo.label',
            ),
            privacyPolicy: t('site.email-opt-in.privacy-policy.fanexpo.label'),
          }}
        >
          <StyledLink
            href={'https://www.informa.com/generic-content/terms--conditions/'}
            target="_blank"
          >
            {t('site.email-opt-in.terms-conditions.fanexpo.label')}
          </StyledLink>
          <StyledLink
            href={'https://www.informa.com/privacy-policy/'}
            target="_blank"
          >
            {t('site.email-opt-in.privacy-policy.fanexpo.label')}
          </StyledLink>
        </Trans>
      </PrivacyPolicyText>
    );
  }

  return (
    <>
      <PrivacyPolicyText
        visualStyles={vStyles}
        data-testid={'email-opt-in-privacy-policy'}
      >
        {t('site.email-opt-in.privacy-policy.definition', {
          buttonText,
          siteName: title,
        })}
      </PrivacyPolicyText>
      <PrivacyPolicyText visualStyles={vStyles}>
        <Trans
          i18nKey="site.email-opt-in.privacy-policy.explanation"
          values={{
            privacy: t('site.email-opt-in.privacy-policy'),
          }}
        >
          <StyledLink
            href={'https://www.informa.com/privacy-policy/'}
            target="_blank"
          >
            {t('site.email-opt-in.privacy-policy')}
          </StyledLink>
        </Trans>
      </PrivacyPolicyText>
    </>
  );
};

PolicyContent.propTypes = {
  buttonText: PropTypes.string,
  pageConfig: PropTypes.shape({
    title: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  pageConfig: state.pageConfig,
});

export default connect(mapStateToProps)(PolicyContent);
